import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaStar, FaShoppingCart } from 'react-icons/fa';
import { useCart } from '../context/CartContext';

function ProductCard({ product }) {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.stopPropagation();
    addToCart(product);
    
    const notification = document.createElement('div');
    notification.className = 'notification';
    notification.textContent = 'Product added to cart successfully!';
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.remove();
    }, 3000);
  };

  const handleCardClick = () => {
    navigate('/product/' + product.id);
  };

  return (
    <div className="product-card" onClick={handleCardClick}>
      <div className="product-image-container">
        <img src={product.image} alt={product.name} className="product-image" />
        {product.badge && <span className="product-badge">{product.badge}</span>}
      </div>
      
      <div className="product-info">
        <h3 className="product-title">{product.name}</h3>
        <p className="product-description">{product.shortDescription}</p>
        
        <div className="product-rating">
          {[...Array(5)].map((_, i) => (
            <FaStar key={i} color={i < product.rating ? '#ffa502' : '#ddd'} />
          ))}
          <span>({product.reviews} reviews)</span>
        </div>
        
        <div className="product-price">£{product.price.toFixed(2)}</div>
        
        <div className="product-actions">
          <button className="btn-primary" onClick={handleAddToCart}>
            <FaShoppingCart /> Add to Cart
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;